import { Component } from '@angular/core'
import { RoutingService, TranslationService, } from '@spartacus/core'
import { distinctUntilChanged, filter, map, mergeMap, shareReplay, switchMap, tap } from 'rxjs/operators'
import { combineLatest, of } from 'rxjs'
import { ProductListComponentService } from '@spartacus/storefront'
import { MbConstants } from '../../../shared/mb-constants'
import { SmartSearchService } from '../../../cms/services/cms-search/smart-search.service'
import { HttpUrlEncodingCodec } from '@angular/common/http'

@Component({
  selector: 'mb-search-results-header',
  templateUrl: './mb-search-results-header.component.html',
  styleUrls: ['./mb-search-results-header.component.scss']
})
export class MbSearchResultsHeaderComponent {

  constants = MbConstants
  query: string | undefined
  hasRedirectUrl = false
  showMatchingResultsHeader = false
  searchTerm: string | undefined
  isNonEmptySearch: boolean = false
  query$ = this.routingService.getRouterState().pipe(
    map(state => state?.state?.params?.['query'] || state?.state?.queryParams?.['query']),
    distinctUntilChanged(),
    tap(query => {
      if (this.query?.toLowerCase() !== String(query).toLowerCase()) {
        this.showMatchingResultsHeader = false
      }
      this.query = query
      /* to check whether the query is :relevance when filter is removed in search page without search term */
      this.isNonEmptySearch = atob(this.query?.split(this.constants.HASH_SYMBOL)?.[1] || '') === this.constants.COLON_RELEVANCE
        && !(!!this.searchTerm)
    }),
    shareReplay(1),
  )
  total$ = this.productListComponentService.model$.pipe(
    filter(data => !!data?.pagination && (!!data?.freeTextSearch || !!data?.currentQuery?.query?.value)),
    tap(results => {
      this.searchTerm = results?.freeTextSearch
      const currentQuery = new HttpUrlEncodingCodec().decodeValue(results?.currentQuery?.query?.value || '') || ''
      if ((results?.freeTextSearch)?.toLowerCase() === this.query?.toLowerCase() || currentQuery.toLowerCase() === this.query?.toLowerCase().replaceAll(' ', this.constants.PLUS_SYMBOL)) {
        this.showMatchingResultsHeader = true
      }
      this.hasRedirectUrl = !!results?.keywordRedirectUrl
    }),
    map(results => results.pagination?.totalResults || 0)
  )
  cmsTotal$ = this.smartSearchService.model$.pipe(
    map(results => results?.numberOfResults || 0)
  )
  searchResultsHeadline$ = combineLatest([this.total$, this.cmsTotal$, this.query$]).pipe(
    switchMap(([productCount, contentCount, query]) => !this.showMatchingResultsHeader && of('')
      || this.translation.translate('pageMetaResolver.search.default_title').pipe(
        mergeMap(defaultQuery => {
          if (this.searchTerm?.length) {
            return this.translation.translate('searchHeading.titleLong', {
              count: productCount + contentCount,
              query: query || defaultQuery,
            })
          } else {
            return this.translation.translate('searchHeading.title', {
              count: productCount + contentCount
            })
          }
        })
      ))
  )

  constructor (private productListComponentService: ProductListComponentService,
               private smartSearchService: SmartSearchService,
               private translation: TranslationService,
               private routingService: RoutingService) {
  }
}
